import { RefObject } from "react";
import { createPortal } from "react-dom";

interface Props {
    children: React.ReactNode;
    ref?: RefObject<HTMLDivElement>
}

export function ModalContainer({ children, ref }: Props) {
    return createPortal(
        <div 
            ref={ref}
            className="fixed inset-0 flex items-center justify-center bg-opacity-50 bg-black z-50 duration-300">
            {children}
        </div>,
        document.getElementById("modal") as HTMLElement ?? <></>
    );
}